import React from 'react';
import { Form, Input, InputNumber, TimePicker } from 'antd';
import './index.scss';
import { EventIcon, SearchIcon } from 'common/customIcons';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';

const { RangePicker } = DatePicker;
type paramType = {
  label?: string | React.ReactElement;
  name: string;
  defaultValue?: any;
  className?: string;
  type?:
    | 'number'
    | 'date'
    | 'dateRange'
    | 'search'
    | 'checkbox'
    | 'checkboxGroup'
    | 'text'
    | 'timePicker'
    | 'dateAndTimePicker'
    | 'email'
    | 'password';
  rules?: [{ required: boolean; message?: string }] | object[];
  placeholder?: string;
  maxLength?: number;
  onChange?: (e: any) => void;
  disabled?: any;
  checkboxText?: string;
  valuePropName?: 'checked' | string;
  prefix?: React.ReactElement;
  suffix?: React.ReactElement;
  min?: number;
  max?: number;
  checked?: boolean;
  onOpenChange?: (open: any) => any;
  onPanelChange?: (value: any, mode: any) => any;
  disabledDate?: any;
  picker?: 'week' | 'quarter' | 'month' | 'year';
  format?: string;
  allowClear?: true | false;
  onWheel?: any;
  ref?: any;
  hasFeedback?: boolean;
};

const conditionalRenderFunc = (props: paramType) => {
  function disabledDate(current: any) {
    const frDate = moment(props?.disabledDate.fromDate)?.format('YYYY-MM-DD');
    const tDate = moment(props?.disabledDate.toDate)
      .add(1, 'days')
      ?.format('YYYY-MM-DD');
    const fromDate = moment(frDate) || undefined;
    const toDate = moment(tDate) || undefined;
    const fromDates = fromDate?.startOf(current) || moment().startOf(current);
    const endDates = toDate?.endOf(current) || moment().endOf(current);
    if (!fromDate && !toDate) {
      return !moment().endOf('week').isAfter(current);
    } else {
      return !(
        fromDates?.isSameOrBefore(current) && endDates?.isAfter(current)
      );
    }
  }

  const disabledTime = (
    current: Moment | null,
    type: 'start' | 'end' | undefined
  ): any => {
    if (type === 'start') {
      return {
        disabledHours: () => {
          const hours = [];
          for (let i = 0; i < 8; i++) {
            hours.push(i);
          }
          return hours;
        },
        disabledMinutes: (hour: number) => {
          if (hour === 8) {
            const minutes = [];
            for (let i = 0; i < 60; i++) {
              minutes.push(i);
            }
            return minutes;
          }
          return [];
        },
      };
    } else if (type === 'end') {
      return {
        disabledHours: () => {
          const hours = [];
          for (let i = 18; i < 24; i++) {
            hours.push(i);
          }
          return hours;
        },
        disabledMinutes: (hour: number) => {
          if (hour === 17) {
            const minutes = [];
            for (let i = 0; i < 60; i++) {
              minutes.push(i);
            }
            return minutes;
          }
          return [];
        },
      };
    }
    return null;
  };

  switch (props?.type || '') {
    case 'number':
      return (
        <InputNumber
          className="w-full rounded"
          placeholder={
            props?.placeholder ? props?.placeholder : props?.name || ''
          }
          maxLength={props?.maxLength}
          onChange={props?.onChange}
          defaultValue={props?.defaultValue ? props?.defaultValue : undefined}
          disabled={props?.disabled}
          min={props?.min || 0}
          max={props?.max || undefined}
          prefix={props?.prefix}
          type="number"
          onWheel={props?.onWheel}
        />
      );
    case 'date':
      return props?.disabledDate ? (
        <DatePicker
          className="w-full rounded"
          suffixIcon={<EventIcon />}
          disabled={props?.disabled}
          format="DD/MM/YYYY"
          disabledDate={disabledDate}
          onChange={props?.onChange}
          allowClear={props?.allowClear}
        />
      ) : (
        <DatePicker
          className="w-full rounded"
          suffixIcon={<EventIcon />}
          disabled={props?.disabled}
          format={props?.format ? props?.format : 'DD/MM/YYYY'}
          picker={props?.picker}
          onChange={props?.onChange}
          allowClear={props?.allowClear}
        />
      );
    case 'dateRange':
      return (
        <RangePicker
          className="w-full rounded"
          disabled={props?.disabled}
          format="DD/MM/YYYY"
          allowClear={props?.allowClear}
        />
      );
    case 'timePicker':
      return (
        <TimePicker
          className="w-full rounded"
          disabled={props?.disabled}
          format="h:mm a"
          use12Hours
        />
      );
    case 'dateAndTimePicker':
      return (
        <DatePicker
          showTime={{
            format: 'HH:mm',
            disabledTime: disabledTime as any,
          }}
          className="w-full rounded"
          suffixIcon={<EventIcon />}
          disabled={props?.disabled}
          format="DD/MM/YYYY h:mm a"
          use12Hours
          onChange={props?.onChange}
        />
      );
    case 'search':
      return (
        <Input
          placeholder={
            props?.placeholder ? props?.placeholder : props?.name || ''
          }
          maxLength={props?.maxLength}
          onChange={props?.onChange}
          prefix={<SearchIcon />}
          className="rounded serchFieldTopbar"
          defaultValue={props?.defaultValue ? props?.defaultValue : undefined}
          disabled={props?.disabled}
        />
      );
    case 'checkbox':
      return (
        <Checkbox
          className={`${props?.className ? props?.className : ''} rounded`}
          disabled={props?.disabled}
          onChange={props?.onChange}
          checked={props?.checked}
        >
          {props?.checkboxText}
        </Checkbox>
      );
    case 'password':
      return (
        <Input.Password
          placeholder={
            props?.placeholder ? props?.placeholder : props?.name || ''
          }
          className="w-full rounded"
          onChange={props?.onChange}
          disabled={props?.disabled}
          autoComplete={'on'}
        />
      );
    default:
      return (
        <Input
          placeholder={
            props?.placeholder ? props?.placeholder : props?.name || ''
          }
          maxLength={props?.maxLength}
          onChange={props?.onChange}
          className="rounded"
          defaultValue={props?.defaultValue ? props?.defaultValue : undefined}
          disabled={props?.disabled}
          prefix={props?.prefix}
          suffix={props?.suffix}
        />
      );
  }
};

export const TFInput: React.FC<paramType> = (props) => {
  return (
    <div className="TFInputWrapper">
      <Form.Item
        label={props?.label}
        name={props?.name}
        rules={props?.rules}
        valuePropName={props?.valuePropName}
        hasFeedback={props?.hasFeedback}
      >
        {conditionalRenderFunc(props)}
      </Form.Item>
    </div>
  );
};
/// =============example =====
// <TFInput
// label="Username"
// name="username"
// rules={[{ required: true, message: 'User name is required' }]}
// />
